import { render, staticRenderFns } from "./TestProgress.vue?vue&type=template&id=1f0b1ba6&scoped=true"
import script from "./TestProgress.vue?vue&type=script&lang=js"
export * from "./TestProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b1ba6",
  null
  
)

export default component.exports